import { ColumnTypeEnum } from '@y42/json-schema';
import { ColumnTypeToTypescriptTypeConverter } from './column-to-typescript-type-converter';

export interface DatasourceColumnModelMeta {
  field_name: string;
  data_type: ColumnTypeEnum;
}

export function sourceColumnConstants(columns: DatasourceColumnModelMeta[]): string {
  return columns
    .map((f) => `declare const @${f.field_name}: ${ColumnTypeToTypescriptTypeConverter(f.data_type)};`)
    .join('\n');
}
